/* eslint-disable pec/import-graphql-hooks-from-local */

import {
  MutationHookOptions as OptionsType,
  MutationTuple,
  OperationVariables,
  useMutation as useApolloMutation,
} from '@apollo/client'
import { DocumentNode } from 'graphql'

// Override useMutation from @apollo/client to use custom defaults

export function useMutation<TData = any, TVariables = OperationVariables>(
  mutation: DocumentNode,
  options?: MutationHookOptions<TData, TVariables>
): MutationTuple<TData, TVariables> {
  return useApolloMutation<TData, TVariables>(mutation, options)
}

export type MutationHookOptions<TData = any, TVariables = OperationVariables> = OptionsType<TData, TVariables>
